import { SMALL_POPUP_WIDTH, XS_POPUP_HEIGHT } from "@/theme/primary";
import Popup from "@components/Popup";
import { Button, MenuItem, Select, SelectChangeEvent, Stack } from "@mui/material";
import { FC, useState } from "react";

interface MessageSelectorPopupProps {
  open: boolean;
  // eslint-disable-next-line no-unused-vars
  handleClose: (value: MissionType | null) => void;
}

const MessageSelectorPopup: FC<MessageSelectorPopupProps> = ({ open, handleClose }) => {
  const [value, setValue] = useState<MissionType>("MESSAGE_1");

  const handleChange = (e: SelectChangeEvent) => {
    setValue(e.target.value as MissionType);
  };

  return (
    <Popup
      title="Message à envoyer"
      open={open}
      onClose={() => handleClose(null)}
      modalSize={{ width: SMALL_POPUP_WIDTH, height: XS_POPUP_HEIGHT }}>
      <Stack justifyContent="space-around" spacing={9}>
        <Stack justifyContent="center" alignItems={"center"} width="100%" margin="auto">
          <Select value={value} label="Message" onChange={handleChange} fullWidth>
            <MenuItem value={"MESSAGE_1"}>Message 1</MenuItem>
            <MenuItem value={"MESSAGE_2"}>Message 2</MenuItem>
            <MenuItem value={"MESSAGE_3"}>Message 3</MenuItem>
            <MenuItem value={"MESSAGE_4"}>Message 4</MenuItem>
            <MenuItem value={"MESSAGE_5"}>Message 5</MenuItem>
          </Select>
        </Stack>
        <Stack direction="row" justifyContent="center" alignItems="center" spacing={5}>
          <Button variant="contained" onClick={() => handleClose(value)} fullWidth>
            Envoyer
          </Button>
          <Button variant="contained" onClick={() => handleClose(null)} fullWidth>
            Annuler
          </Button>
        </Stack>
      </Stack>
    </Popup>
  );
};

export default MessageSelectorPopup;
